import { TimeIntervalType } from '../types'

export const INTERVAL_FORMAT_CODE_MAP: Record<TimeIntervalType, string> = {
  month: 'MMMM'
}
